/* eslint-disable react/destructuring-assignment */

import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import TextField from 'components/ui/TextField'
import formatPhone from 'utils/formatPhone'

type TextFieldProps = {
  label?: string
  description?: string
  placeholder?: string
  autoComplete?: string
  type?: string
  newDesign?: boolean
}

export type Props = TextFieldProps & {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

function InnerFormTextField({
  input,
  label,
  description,
  placeholder,
  newDesign,
  meta: { touched, error: syncError, submitError, submitting }
}: FieldRenderProps<string, HTMLInputElement> & TextFieldProps) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  return (
    <TextField
      description={description}
      disabled={submitting}
      error={showError ? error : null}
      label={label}
      newDesign={newDesign}
      placeholder={placeholder}
      {...input}
    />
  )
}

export default function FormPhoneField({
  name,
  fieldProps = EMPTY_FIELD_PROPS,
  ...innerProps
}: Props) {
  return (
    <Field<string, FieldRenderProps<string, HTMLInputElement>, HTMLInputElement>
      format={(value: string) => (value === '' ? '' : formatPhone(value))}
      name={name}
      parse={(value: string) =>
        value === '' ? '' : value.replace(/[^\d]/g, '').slice(0, 10)
      }
      render={(props) => (
        <InnerFormTextField
          {...props}
          {...innerProps}
          name={name}
          placeholder="(999) 999-9999"
        />
      )}
      {...fieldProps}
    />
  )
}
